module.exports = __webpack_public_path__ + "static/media/work1.2.4e407450.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.2.png
// module id = 517
// module chunks = 4